import { useMemo } from 'react';
import { usePagesQuery } from '../generated/graphql';

export const PAGE_TYPE_LITE_SITE = 'LiteSitePage';

const useIsLiteSite = () => {
  const { data, loading } = usePagesQuery();
  const pages = data?.pages || [];
  const litePage = useMemo(() => pages?.find(({ type }) => type === PAGE_TYPE_LITE_SITE), [pages]);
  return { isLiteSite: !!litePage, loading };
};

export default useIsLiteSite;
